/** Full-screen loader for auth bootstrap and Suspense fallbacks. */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { appTheme, useThemeColors, useThemeStore } from '../shared/theme';
import { MainLoader } from '../components/load-main/MainLoader';

const loader_styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export function NavigationScreenLoader() {
  const c = useThemeColors() ?? useThemeStore.getState().colors;
  const bg = c?.background ?? appTheme.colors.background;
  const tint = c?.primary ?? appTheme.colors.primary;
  return (
    <View style={[loader_styles.root, { backgroundColor: bg }]}>
      <MainLoader size={48} color={tint} />
    </View>
  );
}
